export default {
    "my_inventory": "我的庫存",
    "serving_suggestions": "品飲建議",
    "wine_info": "關於這支酒",
    "serving_temp": "適飲溫度",
    "serving_time": "適飲時間",
    "decanting_time": "醒酒時間",
    "food_pairing": "食物搭配",
    "drink_between": "適飲期",
    "drink_note": "品飲筆記",
    "market_value": "市場價值",
    "add_note": "新增關於這支酒的小筆記吧！"
}